import React from 'react'
 
function CardNemoItem(props) {

    //Parametros de entrada.
    const inputParam_Text = props.text;
    
    //Parametros de componente.

    //Funciones de componente.

    //Eventos de componente.

    //Render de componente.
    return (
        <ol className="steps-le-bu step-no-status-bar">
            <li
                key={inputParam_Text}
                data-step={inputParam_Text}
                className={"step"}
            >
            </li>
        </ol>
    );
}

export default CardNemoItem;
